export const ModalBackgroundColor = {
  WARNING: 'linear-gradient(180deg, #fbeaea 0%, #ffffff 100%)',
  INFO: 'linear-gradient(180deg, #def3ff 0%, #ffffff 100%)',
  PACKAGE_CHANGE: 'linear-gradient(180deg, #fbeaea 0%, #ffffff 100%)',
  GENERIC: '#FFFFFF',
};

export const ErrorMessages = {
  GENERIC: 'Something went wrong, Please try again later.',
  TRIP_DETAILS: {
    COUNTRY_REQUIRED: 'Please select a country',
    DURATION_REQUIRED: 'Please select trip duration',
    ADULT_REQUIRED: 'Please add an adult or a senior citizen to continue',
    INVALID_DATE: 'Current date is not allowed',
    PACKAGE_REQUIRED: 'Please select the coverage type',
  },
};

export const ModalsType = {
  PRICE_BREAKUP: 'price_breakup',
  BENEFITS: 'benefits',
  MANDATORY: 'mandatory',
  WARNING: 'warning',
  INFO: 'info',
  PRICE_UPDATE: 'price-update',
  PACKAGE_CHANGE: 'package-change',
};

export const CoverHeadBackground = {
  medical: 'linear-gradient(291.97deg, #ECFEFF 25.43%, #F3EDFF 74.78%)',
  trip: 'linear-gradient(296.6deg, #FFFBF1 15.55%, #FDF0F9 84.07%)',
  baggage: 'linear-gradient(95.29deg, #EBFBEE 11.74%, #E3FAFC 86.95%)',
  baggaage: 'linear-gradient(95.29deg, #EBFBEE 11.74%, #E3FAFC 86.95%)',
};

export const StoryBackgroundColor = {
  medical: 'rgb(252, 240, 249)',
  trip: 'rgb(226, 245, 255)',
  baggage: 'rgb(239, 233, 251)',
  baggaage: 'rgb(239, 233, 251)',
};

export const StoryAnimationBackgroundColor = {
  medical: 'rgb(251, 233, 246)',
  trip: 'rgb(226, 245, 255)',
  baggage: 'rgb(239, 233, 251)',
  baggaage: 'rgb(239, 233, 251)',
};

export const AdditionalStyles = {
  medical: { paddingBottom: '14px' },
  trip: { padding: '20px 0px 16px' },
  baggage: { padding: '10px 0px 4px' },
  baggaage: { padding: '10px 0px 4px' },
};

export const StoryBorderStyle = {
  medical: '1px solid rgba(252, 194, 215, 1)',
  trip: '1px solid rgba(169, 221, 254, 1)',
  baggage: '1px solid rgba(208, 189, 244, 1)',
  baggaage: '1px solid rgba(208, 189, 244, 1)',
};

export const JourneyState = {
  PACKAGE_SELECTION: 'package_selection',
  TRIP_DETAILS_COLLECTION: 'trip_details_collection',
  MEDICAL_COVER_SELECTION: 'medical_cover_selection',
  TRIP_COVER_SELECTION: 'trip_cover_selection',
  BAGGAGE_COVER_SELECTION: 'baggage_cover_selection',
  BUNDLED_PLAN_SELECTION: 'bundled_plan_selection',
  BUNDLED_ADDON_SELECTION: 'bundled_addon_selection',
  PLAN_SELECTION: 'plan_selection',
  JOURNEY_SUMMARY: 'journey_summary',
  POLICY_INIT: 'policy_init',
  COMPLIANCE_PENDING: 'compliance_pending',
  POLICY_ACTIVATED: 'policy_activated',
  PAYMENT_INITIATED: 'payment_initiated',
  PAYMENT_PENDING: 'payment_pending',
  PAYMENT_FAILED: 'payment_failed',
  POST_PURCHASE_DATA_COLLECTION: 'post_purchase_data_collection',
  POST_POLICY_DATA_COLLECTION_INITIATED:
    'post_policy_data_collection_initiated',
  TRIP_DETAILS_COLLECTION_AND_PACKAGE_SELECTION:
    'trip_details_collection_and_package_selection',
};

export const GROWTHBOOK_UAT = {
  HOST: 'https://growthbook-api.internal.ackodev.com',
  KEY: 'sdk-Z4y19WZBri00dOD2',
};

export const GROWTHBOOK_PROD = {
  HOST: 'https://ab.acko.com/',
  KEY: 'sdk-Pw0f4p0AdN7T11M',
};

export const CAPTCHA_KEY = {
  PROD: 'a146f3ce-fb59-4672-a53a-77c50bf38d3d',
  UAT: 'f9571092-6149-4653-a02d-6e7738a4878d',
};

export const GTM_ID = { PROD: 'GTM-5XMNN6W' };

export const ACKO_GTM_ID = { PROD: 'GTM-TZVHFQH' };

export const GA_ID = { PROD: 'G-801FY3RHXE' };

export const PDP_ICONS = {
  POLICY_INFO: `https://travel.ackoassets.com/images/pdp_web/pdp_policy_info.svg`,
  STEP_1: `https://travel.ackoassets.com/images/desktop/extend_policy_icon.svg`,
  STEP_2: `https://travel.ackoassets.com/images/desktop/update_travelle_icon.svg`,
  STEP_3: `https://travel.ackoassets.com/images/desktop/raise_track icon.svg`,
  QR_CODE: `https://travel.ackoassets.com/images/pdp_web/qrcode.svg`,
  BLUE_ARROW: 'https://travel.ackoassets.com/images/desktop/blue-arrow.svg',
};

export const COMPLIANCE_PENDING_ICONS = {
  TICK_STAGE: `https://travel.ackoassets.com/images/pdp_web/tick_stage.svg`,
  VISA_COMPLIANCE: `https://travel.ackoassets.com/images/pdp_web/visa_compliance.svg`,
};

export const ANIMATIONS = {
  VERIFY_PAYMENT_LOADING: `https://travel.ackoassets.com/images/pdp_web/verify_payment_loading.json`,
  POLICY_ACTIVATED: `https://travel.ackoassets.com/images/pdp_web/policy_activated.json`,
  MEDICAL_PERSUASION: `https://travel.ackoassets.com/images/medical/persuasion_new.json`,
  THUMBS_UP: 'https://travel.ackoassets.com/images/visa2fly/ThumbsUp.json',
  GIFT_BOX: 'https://travel.ackoassets.com/images/coupons/gift-box.json',
  CONFETTI: 'https://travel.ackoassets.com/images/coupons/side-confetti.json',
};

export const TRAVELLER_DETAILS_ICONS = {
  PERSON: `https://travel.ackoassets.com/images/pdp_web/personal_details.svg`,
  DROPDOWN: `https://travel.ackoassets.com/images/pdp_web/dropdown.svg`,
};

export const ASSETS = {
  ACKO_LOGO_DARK:
    'https://acko-brand.ackoassets.com/brand/vector-svg/gradient/gradient-horizontal.svg',
  ACKO_LOGO_LIGHT:
    'https://acko-brand.ackoassets.com/brand/vector-svg/gradient/horizontal-reverse.svg',
  BACK_ARROW: 'https://travel.ackoassets.com/images/fe_icons/back-arrow.svg',
  BUNDLE_CHANGE:
    'https://travel.ackoassets.com/images/fe_icons/bundleChange.svg',
  SHOW_SAMPLE_POLICY:
    'https://travel.ackoassets.com/images/fe_icons/show-sample-policy.svg',
  CIRCULAR_LOADER:
    'https://travel.ackoassets.com/images/fe_icons/circular-loader.gif',
  CLOSE_CROSS_MODAL:
    'https://travel.ackoassets.com/images/fe_icons/close-cross-modal.svg',
  CLOSE: 'https://travel.ackoassets.com/images/fe_icons/close.svg',
  DETAILS_MISMATCH:
    'https://travel.ackoassets.com/images/fe_icons/details-mismatch.svg',
  DISCOUNT: 'https://travel.ackoassets.com/images/fe_icons/discount.svg',
  FALLEN_GLASS:
    'https://travel.ackoassets.com/images/fe_icons/fallen-glass.svg',
  HAMBURGER_DARK:
    'https://travel.ackoassets.com/images/fe_icons/hamburger-dark.svg',
  HAMBURGER_LIGHT:
    'https://travel.ackoassets.com/images/fe_icons/hamburger-light.svg',
  HELP: 'https://travel.ackoassets.com/images/fe_icons/help.svg',
  LOADER: 'https://travel.ackoassets.com/images/fe_icons/loader.gif',
  MINUS: 'https://travel.ackoassets.com/images/fe_icons/minus.svg',
  PRICE_UPDATED:
    'https://travel.ackoassets.com/images/fe_icons/price-updated.svg',
  WINDOW_DARK: 'https://travel.ackoassets.com/images/fe_icons/window-dark.svg',
  WINDOW_LIGHT:
    'https://travel.ackoassets.com/images/fe_icons/window-light.svg',
  GREEN_TICK: 'https://travel.ackoassets.com/images/green_tick.svg',
  GREEN_TICK_WITHOUT_BORDER:
    'https://travel.ackoassets.com/images/travel_pass/address/tick.svg',
  BAGGAGE_DELAY: 'https://travel.ackoassets.com/images/gifs/baggage-delay.gif',
  FLIGHT_DELAY: 'https://travel.ackoassets.com/images/gifs/flight-delay.gif',
  DOC_LOADER: 'https://travel.ackoassets.com/images/gifs/docLoader.gif',
  SUCCESS: 'https://travel.ackoassets.com/images/gifs/success.gif',
  PACKAGE_SELECTION_FOOTER:
    'https://travel.ackoassets.com/images/package-selection-footer.svg',
  KYC_ICON: 'https://travel.ackoassets.com/images/kyc/kyc-icon.svg',
  V2F_HEAD_IMAGE: 'https://travel.ackoassets.com/images/visa2fly/v2fSky.svg',
  EVISA: 'https://travel.ackoassets.com/images/visa2fly/evisa.png',
  V2F_CARD_BORDER:
    'https://travel.ackoassets.com/images/visa2fly/v2f-card-border.svg',
  SEARCH_ICON: 'https://travel.ackoassets.com/images/visa2fly/search-icon.svg',
  STAR_BULLET: 'https://travel.ackoassets.com/images/visa2fly/star-bullet.svg',
  BORDERED_GREEN_TICK:
    'https://travel.ackoassets.com/images/visa2fly/border-green-tick.svg',
  MEDICAL_PLUS_SIGN:
    'https://travel.ackoassets.com/images/visa2fly/hospital-plus-sign.svg',
  IN_FLIGHT_CABIN:
    'https://travel.ackoassets.com/images/visa2fly/in-flight.svg',
  TRAVELLER_WITH_BAG:
    'https://travel.ackoassets.com/images/visa2fly/traveller-with-bag.svg',
  GRAY_FALLEN_GLASS:
    'https://travel.ackoassets.com/images/visa2fly/fallen-glass-gray.svg',
  SKY_VIDEO: 'https://travel.ackoassets.com/images/visa2fly/Sky.webm',
  RELAX_CHAIR: 'https://travel.ackoassets.com/images/visa2fly/relax.svg',
  FLIGHT_SKY: 'https://travel.ackoassets.com/images/visa2fly/plane-sky.jpg',
  GIFT_BOX: 'https://travel.ackoassets.com/images/coupons/gift-box.svg',
  WARNING_SIGN: 'https://travel.ackoassets.com/images/coupons/warning-sign.svg',
  SAD_DOG: 'https://travel.ackoassets.com/images/coupons/dog.svg',
  BLUE_SHIELD: 'https://travel.ackoassets.com/images/coupons/blue-shield.svg',
  SAMPLE_POLICY:
    'https://travel.ackoassets.com/images/fe_icons/sample-travel-policy.pdf',
  NEW_SAMPLE_POLICY:
    'https://travel.ackoassets.com/images/fe_icons/new-sample-travel-policy.pdf',
  NOTE_ICON: 'https://travel.ackoassets.com/images/info.svg',
  CLOUD_1:
    'https://travel.ackoassets.com/images/travel_pass/landing_page/clouds.svg',
  CLOUD_2:
    'https://travel.ackoassets.com/images/travel_pass/landing_page/clouds.svg',
  THUNDER_STROKES:
    'https://travel.ackoassets.com/images/travel_pass/landing_page/thunder_strokes.svg',
  TRAVEL_PASS_INTRO:
    'https://travel.ackoassets.com/images/travel_pass/video/travel_pass_intro.mp4',
  SHIELD_SUCCESS_TICK:
    'https://travel.ackoassets.com/images/travel_pass/status/success.svg',
  TRAVEL_PASS_CARD:
    'https://travel.ackoassets.com/images/travel_pass/landing_page/travel_pass_card.png',
  OTHER_ADDRESS_TYPE:
    'https://travel.ackoassets.com/images/travel_pass/address/other.svg',
  HOME_TAG_ICON:
    'https://travel.ackoassets.com/images/travel_pass/address/home_small.svg',
  WORK_TAG_ICON:
    'https://travel.ackoassets.com/images/travel_pass/address/work_small.svg',
  OTHER_TAG_ICON:
    'https://travel.ackoassets.com/images/travel_pass/address/other_small.svg',
  GREEN_OFFER_ICON: 'https://travel.ackoassets.com/images/green_offer.svg',
  PURPLE_OFFER_ICON: 'https://travel.ackoassets.com/images/purple_offer.svg',
  TRAVEL_PASS_BACKGROUND:
    'https://travel.ackoassets.com/images/travel-pass-background.png',
  BACK_ARROW_LIGHT:
    'https://travel.ackoassets.com/images/travel_pass/pdp/back_arrow_white.svg',
  TRAVEL_PASS_TNC: 'https://travel.ackoassets.com/docs/flight_pass_tnc.pdf',
  ENVELOPE: 'https://travel.ackoassets.com/images/fe_icons/envelope.svg',
  PHONE: 'https://travel.ackoassets.com/images/phone.svg',
  VISA_SKY_DESKTOP_VIDEO:
    'https://travel.ackoassets.com/images/visa2fly/desktop/visa_desktop_header.webm',
  VISA_SKY_DESKTOP_POSTER:
    'https://travel.ackoassets.com/images/visa2fly/desktop/visa-desktop-poster.png',
  BLACK_SHIELD_TICK:
    'https://travel-uat-assets.ackodev.com/images/insurance_shield.svg',
  YELLOW_DISCOUNT:
    'https://travel.ackoassets.com/images/fe_icons/yellow-discounts.svg',
  PURPLE_DISCOUNT:
    'https://travel.ackoassets.com/images/fe_icons/purple-2-flag-discount.svg',
  BLACK_INFO_ICON:
    'https://travel.ackoassets.com/images/fe_icons/black-info-icon.svg',
  ALERT_SIGN_BOARD:
    'https://travel.ackoassets.com/images/fe_icons/alert-sign-board.svg',
  FAMILY_SHIELD:
    'https://travel.ackoassets.com/images/fe_icons/family-shield.svg',
  HAND_PICKING_BLOCK:
    'https://travel.ackoassets.com/images/fe_icons/hand-picking-block.svg',
  POLICY_READY:
    'https://travel.ackoassets.com/images/fe_icons/policy-ready.svg',
  PEOPLE: 'https://travel.ackoassets.com/images/fe_icons/people.svg',
  FLIGHT: 'https://travel.ackoassets.com/images/fe_icons/flight.png',
  BULB_DARK: 'https://travel.ackoassets.com/images/fe_icons/bulb-dark.svg',
  PLANE_WITH_TRAIL:
    'https://travel.ackoassets.com/images/package/airplane-with-trail.png',
  BAGGAGE_DELAY_ICON:
    'https://travel.ackoassets.com/images/package/baggage-delay.svg',
  BUNDLED_ICON: 'https://travel.ackoassets.com/images/package/bundled-icon.svg',
  CUSTOMER_SUPPORT:
    'https://travel.ackoassets.com/images/package/customer-support.svg',
  EDIT_DOCUMENT:
    'https://travel.ackoassets.com/images/package/edit-document.svg',
  FLIGHT_DELAY_ICON:
    'https://travel.ackoassets.com/images/package/flight-delay.svg',
  FLIGHT_TAKE_OFF:
    'https://travel.ackoassets.com/images/package/flight-take-off.svg',
  HEALTH_INSURANCE:
    'https://travel.ackoassets.com/images/package/health-insurance.svg',
  HOSPITAL: 'https://travel.ackoassets.com/images/package/hospital.svg',
  PAY_MONEY: 'https://travel.ackoassets.com/images/package/pay-money.svg',
  POEPLE: 'https://travel.ackoassets.com/images/package/people.svg',
  SEE_ALL_COVERAGE:
    'https://travel.ackoassets.com/images/package/see-all-coverage.svg',
  TRAVEL_INTRO_DESKTOP:
    'https://travel.ackoassets.com/images/package/travel-intro-desktop.mp4',
  TRAVEL_INTRO_MOUNTAINS:
    'https://travel.ackoassets.com/images/package/mountains-intro.mp4',
  TRAVEL_LANDING_INTRO:
    'https://travel.ackoassets.com/images/package/travel-landing-intro.mp4',
  UNBUNDLED_SVG:
    'https://travel.ackoassets.com/images/package/unbundled-icon.svg',
  WHEN_ICON: 'https://travel.ackoassets.com/images/package/when-icon.svg',
  WHITE_SEARCH_ICON:
    'https://travel.ackoassets.com/images/package/white-search-icon.svg',
  WHO_ICON: 'https://travel.ackoassets.com/images/package/who-icon.svg',
  CUSTOMER_SUPPORT_PHONE:
    'https://travel.ackoassets.com/images/package/customer_support_phone.svg',
  MEDICAL_COVER_PHONE:
    'https://travel.ackoassets.com/images/package/cover-1.svg',
  FLIGHT_COVER_PHONE:
    'https://travel.ackoassets.com/images/package/cover-2.svg',
  BLUE_TICK: 'https://travel.ackoassets.com/images/package/blue-tick.svg',
  DEFAULT_USER:
    'https://travel.ackoassets.com/images/fe_icons/default-user.png',
  VISA_COMPLIANT:
    'https://travel-uat-assets.ackodev.com/images/claim_resolved.svg',
  AIR_BALLONS_BACKGROUND:
    'https://travel.ackoassets.com/images/fe_icons/air-ballons.png',
  DARK_MOUNTAINS_BACKGROUND:
    'https://travel.ackoassets.com/images/package/mountains-bg.png',
  MOUNTAINS_BACKGROUND:
    'https://travel.ackoassets.com/images/fe_icons/mountains.png',
};

export const INTERNATIONAL_DESKTOP_ASSETS = {
  LANDING_PAGE_BG:
    'https://travel.ackoassets.com/images/desktop/international-travel-desktop-bg.svg',
  CUSTOMER_SUPPORT:
    'https://travel.ackoassets.com/images/desktop/customer-support.svg',
  PASSPORT_ICON: 'https://travel.ackoassets.com/images/desktop/passport.svg',
  MONEY_ICON: 'https://travel.ackoassets.com/images/desktop/money.svg',
  NOTES_ICON: 'https://travel.ackoassets.com/images/desktop/notes.svg',
  RIGHT_ARROW_ICON:
    'https://travel.ackoassets.com/images/desktop/right-arrow.svg',
  INFO_ICON: 'https://travel.ackoassets.com/images/desktop/info-icon.svg',
  WHITE_TICK_ICON:
    'https://travel.ackoassets.com/images/desktop/white-tick-icon.svg',
  BLACK_TICK_ICON:
    'https://travel.ackoassets.com/images/desktop/black-tick.svg',
  GOLDEN_STAR: 'https://travel.ackoassets.com/images/desktop/golden-star.svg',
  JOURNEY_BACKGROUND:
    'https://travel.ackoassets.com/images/desktop/journey-background.jpg',
};

export const NEWRELIC_URL =
  'https://acko-frontend-prod.ackoassets.com/_next_static/js/newrelic/travel-newrelic.js';

export const VAS_LOADER_DATA = {
  icon_url: ASSETS.DOC_LOADER,
  title: 'Getting your application ready',
  sub_title: 'Visa assistance powered by our trusted partner, Visa2fly',
};

export const PAYMENT_LOADER_DATA = {
  title: 'Hold on for a moment',
  sub_title: 'Payment being processed',
  icon_url: ASSETS.DOC_LOADER,
};

export const COUPON_STATUS = {
  APPLICABLE: 'Applicable',
  NON_APPLICABLE: 'NonApplicable',
  APPLIED: 'Applied',
};

export const COUPON_HEADER_BACKGROUND = {
  Applicable: 'linear-gradient(90.18deg, #451999 39.07%, #B191ED 138.56%)',
  NonApplicable: 'rgba(248, 247, 252, 1)',
  Applied:
    'linear-gradient(90.16deg, #451999 -160.78%, #B191ED -48.81%, #EFE9FB 132.59%)',
};
